import React from 'react';

export const PaymentTermsCheck = ({ checked, onChange, testId = 'payment-terms-checkbox' }) => (
  <label className="flex items-start gap-3 cursor-pointer text-xs text-zinc-400 leading-relaxed" data-testid={`${testId}-label`}>
    <input
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      className="mt-0.5 w-4 h-4 shrink-0 accent-[#C41E3A]"
      data-testid={testId}
    />
    <span>
      I agree to the plan terms: the plan and each Pro feature are valid for the period shown, renewals are not automatic, and payments are subject to the{' '}
      <a href="/terms" target="_blank" rel="noopener noreferrer" className="text-[#C41E3A] underline">Terms of Service</a> (including the refund policy) and{' '}
      <a href="/privacy" target="_blank" rel="noopener noreferrer" className="text-[#C41E3A] underline">Privacy Policy</a>.
    </span>
  </label>
);
